<template>
  <div :class="size">
    <div class="left-panel-wraper animate__animated" v-if="isPanel">
      <div class="logo">
        <a href="/">
          <img src="/static/img/logo_small.svg" />
        </a>
      </div>
      <div class="menu">
        <div class="button-menu">
          <img src="/static/img/menu_button.svg" v-on:click="isMenu" class="is-menu-button" />
        </div>
      </div>
      <div class="social-wrapper">
        <div class="social">
          <a href="https://wa.me/79910830833" style="text-align: center;">
            <img
              style="width: 36px;"
              src="/static/img/icon_whatsapp_black.svg"
              class="margin-right-1"
            />
          </a>
          <a href="https://vk.com/mob_advokat">
            <img
              style="width: 50px;"
              src="/static/img/vk-02-01.svg"
              class="margin-right-1"
            />
          </a>
          <a href="https://www.youtube.com/channel/UCOyKsErmFTcl23B2ckPA0MQ">
            <img
              style="width: 50px;"
              src="/static/img/you-02-01.svg"
              class="margin-right-1"
            />
          </a>
        </div>
      </div>
    </div>
    <div class="left-menu-wraper animate__animated animate__fadeInLeft "  v-if="!isPanel">
      <div class="menu-wrap-stepper one-menu">
        <div class="row">
          <div class="col-10">
            <a href="/">
              <img src="/static/img/logo_full.svg" />
            </a>
          </div>
          <div class="col-2" style="text-align: -webkit-right;">
            <img src="/static/img/closse.svg" style="cursor: pointer" v-on:click="isMenu" />
          </div>
        </div>
        <div  class="row menu-item">
          <ui_btn type="main-btn full-width" v-on:click="toHelp">
            Срочная помощь адвоката
          </ui_btn>
        </div>
      </div>
      <div class="menu-wrap-stepper two-menu">
        <div class="acord-custom" :class="menu.opened ? 'acord-custom-closse' : '' " v-for="(menu, index) in menuList" :key="'menu'+index">
          <div class="header" @click="menu.opened = !menu.opened">
            <div class="text">
              {{menu.name}}
            </div>
            <img :class="menu.opened ? 'open-menu' : ''" src="/static/img/Accord-controll.svg" />
          </div>
          <template v-if="menu.opened">
            <div v-for="(item, index) in menu.routs" :key="index+'menu-item'" class="item" @click="onClickToItem(item.href)">
              {{item.name}}
            </div>
          </template>
        </div>
      </div>
      <div class="menu-wrap-stepper three-menu">
        <div class="social-row">
          <a href="https://wa.me/79910830833">
            <img
              style="width: 36px;"
              src="/static/img/icon_whatsapp_black.svg"
              class="margin-right-1"
            />
          </a>
          <a href="https://vk.com/mob_advokat">
            <img
              style="width: 50px;"
              src="/static/img/vk-02-01.svg"
              class="margin-right-1"
            />
          </a>
          <a href="https://www.youtube.com/channel/UCOyKsErmFTcl23B2ckPA0MQ">
            <img
              style="width: 50px;"
              src="/static/img/you-02-01.svg"
              class="margin-right-1"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from "vuex";

export default {
  data: () => ({
    isPanel: true,
    size: "menu-hide menu-all is-width-zero",
    menuList: [
      {
        name: 'Клиенту',
        opened: false,
        routs: [
          {
            name: 'Безопасная сделка',
            href: '/safety'
          },
          {
            name: 'Поиск адвоката',
            href: '/search'
          },
          {
            name: 'Отмена судебного приказа',
            href: '/cancel'
          }
        ]
      },
      {
        name: 'Адвокату',
        opened: false,
        routs: [
          {
            name: 'Страхование',
            href: '/insurance'
          },
          {
            name: 'Презентация сервиса',
            href: '/service'
          }
        ]
      },
      {
        name: 'О сервисе',
        opened: false,
        routs: [
          {
            name: 'О сервисе',
            href: '/service'
          },
          {
            name: 'Как это работает?',
            href: '/work'
          },
          {
            name: 'Политика конфиденциальности',
            href: '/privacy'
          }
        ]
      }
    ]
  }),
  watch: {
    getUser(to, from) {
      if (this.getUser && this.getUser.role_id === 3) {
        this.menuList.push({
          name: 'Админу',
          opened: false,
          routs: [
            {
              name: 'Финансовая статистика',
              href: '/admin/finance_statistic'
            },
            {
              name: 'Оставленные заявки',
              href: '/admin/support'
            },
            {
              name: 'Список Адвокатов Министерства Юстиции',
              href: '/admin/ministry_of_justice'
            },
            {
              name: 'Список Судей',
              href: '/admin/judges'
            },
            {
              name: 'Управление пользователями',
              href: '/admin/user'
            },
            {
              name: 'Модерация адвокатов',
              href: '/admin/lawyers'
            },
            {
              name: 'Споры',
              href: '/admin/list_disputes'
            },
            {
              name: 'Настройки',
              href: '/admin/settings'
            }
          ]
        })
      }
    }
  },
  mounted(){
    if(this.getUser && this.getUser.role_id == 3){
      this.menuList.push({
        name: 'Админу',
        opened: false,
        routs: [
          {
            name: 'Финансовая статистика',
            href: '/admin/finance_statistic'
          },
          {
            name: 'Оставленные заявки',
            href: '/admin/support'
          },
          {
            name: 'Список Адвокатов Министерства Юстиции',
            href: '/admin/ministry_of_justice'
          },
          {
            name: 'Список Судей',
            href: '/admin/judges'
          },
          {
            name: 'Управление пользователями',
            href: '/admin/user'
          },
          {
            name: 'Модерация адвокатов',
            href: '/admin/lawyers'
          },
          {
            name: 'Споры',
            href: '/admin/list_disputes'
          },
          {
            name: 'Настройки',
            href: '/admin/settings'
          }
        ]
      })
    }
  },
  methods: {
    async onClickToItem(href){
      await this.isMenu()
      this.$router.push(href);
    },
    isMenu(){
      this.isPanel = !this.isPanel;
      if(this.isPanel){
        this.size = " menu-all menu-hide is-width-zero";
      }else{
        this.size = "menu-open menu-all ";
      }
    },
    async toHelp(){
      await this.isMenu()
      this.$root.$emit('modal.applying');
    },

  },
  computed: mapGetters(['getUser']),
};
</script>

<style>
.social-row{
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.menu-open .button {
  font-size: 14px !important;
}
.menu-wrap-stepper{
  width: 100%;
  padding: 0 36px;
}
.acord-custom .item {
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 131.5%;
  color: #000000;
  padding: 5px 0;
  cursor: pointer;
}
.acord-custom-closse {
  padding: 30px 0;
}
.acord-custom .open-menu{
  transform: rotate(180deg);
}
.acord-custom{
  border-bottom: 1px solid #AFAFAF;
}
.acord-custom .header .text{
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: 400;
  font-size: 27px;
  line-height: 37px;
  color: #000000;
}
@media (max-width: 1650px) {
  .acord-custom .header .text{
    font-size: 24px;
  }
}
@media (max-width: 1350px) {
  .acord-custom .header .text{
    font-size: 20px;
  }
}
.acord-custom .header img{
  width: 27px;
  height: 15px;
}
.acord-custom .header{
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 30px 0;
  cursor: pointer;
}
.menu .button-menu{
  height: 70px;
  width: 70px;
  background: #ECECEC;
  border-radius: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.menu .button-menu img{
  width: 43px;
}
.two-menu{
  overflow: auto;
}
.three-menu{
  padding: 1em 0;
}
.menu-all{
  padding: 0;
  padding-left: 0;
  padding-right: 0;
  position: absolute;
  height: 100%;
  z-index: 99;
  display: flex;
  width: 151px;
  flex-direction: column;
  place-content: center;
}
.social a{
  margin-bottom: 1em;
}
.is-menu-button{
  cursor: pointer;
}
.menu-item{
  margin: 1em 0em 4em 0em;
}
.left-menu-wraper{
  background: white;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  border-radius: 0px 40px 40px 0px;
}
a:link {
  text-decoration: none;
}
a:hover {
  text-decoration: none;
}
.menu-item a{
  font-family: 'Helvetica';
  font-style: normal;
  font-weight: normal;
  font-size: 26px;
  color: #000000;
}
.left-panel-wraper{
  background: white;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  border-radius: 0px 40px 40px 0px;
}
.left-panel-wraper .logo img{
  height: 75px;
}
.social{
  display: flex;
  flex-direction: column;
}
.three-menu a{
  margin-right: 1em;
}
.menu-item .red-button{
    margin-right: 5%;
}
.red-button{
    border: none;
    background: #981010;
    border-radius: 36px;
    font-family: 'Helvetica';
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    text-align: center;
    color: #FFFFFF;
    padding: 0.5em 1em;
    outline: none !important;
}
.grey-button{
    /* margin-left: -6%; */
    border: none;
    background: #C4C4C4;
    border-radius: 36px;
    font-family: 'Helvetica';
    font-style: normal;
    font-weight: normal;
    font-size: 21px;
    text-align: center;
    color: #FFFFFF;
    padding: 0.5em 1em;
    outline: none !important;
}

.red_background {
  background: #9d1d1d !important;
}

.menu-open{
  width: 379px;
}

@media (max-width: 1150px) {
  .menu-item a{
    font-size: 18px;
  }
  .red-button{
    font-size: 13px;
    padding: 0.5em 1em;
  }
  .grey-button{
    font-size: 13px;
    padding: 0.5em 1em;
  }
  .one-menu .col-2{
    padding-left: 0;
  }
}
@media (max-width: 1450px) {
  .menu-item a{
    font-size: 23px;
  }
  .red-button{
    font-size: 18px;
    padding: 0.5em 1em;
  }
  .grey-button{
    font-size: 18px;
    padding: 3% 6% 3% 6%
  }
  .one-menu .col-2{
    padding-left: 0;
  }
}
@media (min-width: 850px) {
  .left-menu-wraper{
    height: 100vh;
  }
  .social-wrapper {
    width: 100%;
    text-align: -webkit-left;
  }
  .social-wrapper .social{
    width: max-content;
  }
  /* .menu-open .left-menu-wraper{
    border-radius: 0px 40px 40px 0px;
    margin-top: 35px;
    height: calc(100vh - 70px);
  }
  .menu-hide .left-menu-wraper{
    border-radius: 0px 40px 40px 0px;
    margin-top: 35px;
    height: calc(100vh - 70px);
  } */
}
@media (max-width: 850px) {
  .left-menu-wraper{
    height: 100vh;
    border-radius: 0;
  }
  .is-width-zero{
    max-width: 0;
  }
  .menu-all{
    position: fixed;
    overflow-x: hidden;
    z-index: 1999;
    height: 100%;
    width: 100%;
  }
  .left-panel-wraper{
    display: none;
  }
}
.logo{
  height: 75px;
}


</style>



// WEBPACK FOOTER //
// menu.vue?6d00f27d